<template lang="pug">
  LayoutDefault
    .page: .container-fluid
      .section: .card: .card--body
        .heading--section Trust Balance
        
        Loading(:isLoading="isDataLoading", type="bar")
          DataTable.mt-4(
            :records="allCash", 
            :headers="headers", 
            :displaySearch="false", 
            :displayPagination="false",
            :emptyDisplayMessage="`No records found. You are currently do not have any trust balance.`",
            tableBreak="xsm",
          )
      .section.text--color_grey
        small Do take note that the trust balances displayed above are updated as at “LAST UPDATED ON” date and time. These data are not real time.      
        
</template>



<script>
import requestHandlers from '../../mixins/requestHandlers';  
import DataTable from '../../components/DataTable';
import Loading from '../../components/Loading';

export default {
  name: 'portfolioCash',
  mixins: [requestHandlers],
  components: {
    DataTable,
    Loading
  },

  data() {
    return {
      allCash: [],
      headers: [
        {
          id: 'clientCode',
          text: 'Account',
          type: 'string',
          colWidth: 20,
          colAlignment: 'center',
        },
        {
          id: 'currency',
          text: 'Currency',
          type: 'string',
          colWidth: 20,
          colAlignment: 'center',
        },
        {
          id: 'balance',
          text: 'Balance',
          type: 'number',
          filter: 'twoDecimal',
          colWidth: 20,
          colAlignment: 'center',
        },
        {
          id: 'myrBalance',
          text: 'MYR Balance',
          type: 'number',
          filter: 'twoDecimal',
          colWidth: 20,
          colAlignment: 'center',
        },
        {
          id: 'lastUpdate',
          text: 'Last Update On',
          type: 'lastUpdate',
          colWidth: 20,
          colAlignment: 'center',
        },        
      ]
    }
  },

  computed: {
  },

  methods: {
    async FETCH_RECORDS() {
      this.REQUEST_INIT();

      try {
      	let { data: { data: trust } } = await this.$axios.get('/Portfolio/TrustBalance');
      	this.allCash = trust;

      } catch(error) {
      	this.HANDLE_ERROR_GENERIC(error);

      } finally {
      	this.REQUEST_FINALLY()

      }
    }
  },

  created() {
    this.FETCH_RECORDS();
  },
}

</script>
